import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'daylabel'
})
export class DaylabelPipe implements PipeTransform {

  transform(value: string | Date, timeZone: string = 'UTC'): string {
    // Convert the input date to the specified time zone
    const inputDate = new Date(value);
    const convertedDate = new Date(inputDate.toLocaleString('en-US', { timeZone }));

    const now = new Date();
    const currentDate = new Date(now.toLocaleString('en-US', { timeZone }));

    // Check for Today
    if (
      convertedDate.getDate() === currentDate.getDate() &&
      convertedDate.getMonth() === currentDate.getMonth() &&
      convertedDate.getFullYear() === currentDate.getFullYear()
    ) {
      return 'Today';
    }

    // Check for Tomorrow
    const tomorrow = new Date(currentDate);
    tomorrow.setDate(currentDate.getDate() + 1);

    if (
      convertedDate.getDate() === tomorrow.getDate() &&
      convertedDate.getMonth() === tomorrow.getMonth() &&
      convertedDate.getFullYear() === tomorrow.getFullYear()
    ) {
      return 'Tomorrow';
    }

    // Otherwise, return the day name
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return days[convertedDate.getDay()];
  }

}
